import { twMerge } from "tailwind-merge";
import { useMediaQuery } from "usehooks-ts";
import { H4 } from "@sellar-io/components";

export const SellarCreditTabSummary = () => {
  const isDesktop = useMediaQuery("(min-width: 1200px)");

  return (
    <>
      <div
        className={twMerge(
          "flex flex-col gap-2 border-zinc-300 bg-white",
          isDesktop ? "rounded-lg border" : "border-b",
        )}
      >
        <div className="flex flex-col px-4 py-2">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-0">
            <H4 className="mb-2">Sellar Credit tab</H4>
          </div>

          <div className="text-zinc-500">
            This view shows your historical orders facilitated by Hokodo. Any
            orders placed using Sellar Credit from 28/11/2025 are now
            facilitated by Two Inc. Any outstanding actions required on your
            Hokodo account are listed below.
          </div>
        </div>
      </div>
    </>
  );
};
